<template>
  <div>
    <Dropdown
      :stop-propagation="true"
      :style="{width: '100%', position: 'relative'}"
      class="customDrop"
      placement="bottom-start"
      trigger="click"
    >
      <Input
        :value="valueStr"
        @on-clear="clearV"
        clearable
        icon="md-time"
        placeholder="请选择时间"
        readonly
      />

      <Dropdown-menu slot="list">
        <template v-if="type == 'time'">
          <div class="timeOptionContainer">
            <div class="hourContainer">
              <!-- <GeminiScrollbar :autoshow="true" :style="{width: '60px'}"> -->
              <template v-for="(item, index) in hourOptins">
                <div
                  :class="item == selectH1?'active timeItem':'timeItem'"
                  :key="item + '-h'"
                  @click.stop="changeH1(item, index)"
                >{{item}}</div>
              </template>
              <!-- </GeminiScrollbar> -->
            </div>
            <div class="minContainer">
              <!-- <GeminiScrollbar :autoshow="true" :style="{width: '60px'}"> -->
              <template v-if="selectH1 == '24'">
                <div
                  :class="'00' == selectM1?'active timeItem':'timeItem'"
                  @click.stop="changeM1('00', 0)"
                >00</div>
              </template>
              <template v-else>
                <template v-for="(item, index) in minOptins">
                  <div
                    :class="item == selectM1?'active timeItem':'timeItem'"
                    :key="item + '-m'"
                    @click.stop="changeM1(item, index)"
                  >{{item}}</div>
                </template>
              </template>
              <!-- </GeminiScrollbar> -->
            </div>
          </div>
        </template>
        <template v-else>
          <div class="timeRangeBox">
            <div>
              <div class="timeRangeTitle">开始时间</div>
              <div class="timeOptionContainer">
                <div class="hourContainer">
                  <!-- <GeminiScrollbar :autoshow="true" :style="{width: '60px'}" id="hourS1"> -->
                  <template v-for="(item, index) in hourOptins">
                    <div
                      :class="item == selectH1?'active timeItem':'timeItem'"
                      :key="item + '-h'"
                      @click.stop="changeH1(item, index)"
                      v-if="item != '24'"
                    >{{item}}</div>
                  </template>
                  <!-- </GeminiScrollbar> -->
                </div>
                <div class="minContainer">
                  <!-- <GeminiScrollbar :autoshow="true" :style="{width: '60px'}"> -->
                  <div
                    :class="item == selectM1?'active timeItem':'timeItem'"
                    :key="item + '-m'"
                    @click.stop="changeM1(item, index)"
                    v-for="(item, index) in minOptins"
                  >{{item}}</div>
                  <!-- </GeminiScrollbar> -->
                </div>
              </div>
            </div>
            <div>
              <div class="timeRangeTitle">结束时间</div>
              <div class="timeOptionContainer">
                <div class="hourContainer">
                  <!-- <GeminiScrollbar :autoshow="true" :style="{width: '60px'}"> -->
                  <div
                    :class="item == selectH2?'active timeItem':'timeItem'"
                    :key="item + '-h'"
                    @click.stop="changeH2(item)"
                    v-for="item in hourOptins"
                  >{{item}}</div>
                  <!-- </GeminiScrollbar> -->
                </div>
                <div class="minContainer">
                  <!-- <GeminiScrollbar :autoshow="true" :style="{width: '60px'}"> -->
                  <template v-if="selectH2 == '24'">
                    <div
                      :class="'00' == selectM2?'active timeItem':'timeItem'"
                      @click.stop="changeM2('00')"
                    >00</div>
                  </template>
                  <template v-else>
                    <template v-for="item in minOptins">
                      <div
                        :class="item == selectM2?'active timeItem':'timeItem'"
                        :key="item + '-m'"
                        @click.stop="changeM2(item)"
                        v-if="('00' == selectH2 && item != '00') || '00' != selectH2"
                      >{{item}}</div>
                    </template>
                  </template>
                  <!-- </GeminiScrollbar> -->
                </div>
              </div>
            </div>
          </div>
        </template>
      </Dropdown-menu>
    </Dropdown>
  </div>
</template>
<script>
export default {
  name: 'sunflowerTimeSelect',
  props: {
    type: {
      required: false,
      default: 'time'
    },
    defauleValue: {
      required: false
    },
    title: {
      required: false,
      default: '提交成功'
    },
    step: {
      required: false,
      default: 1
    },
  },
  computed: {
    hourOptins: function () {
      return ['00', '01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24']
    },
    minOptins: function () {
      let arr = []
      for (let start = 0; start < 60; start = (start + this.step)) {
        if (start < 10) {
          arr.push('0' + start)
        } else {
          arr.push(start)
        }
      }
      return arr
    }
  },
  watch: {
    defauleValue: {
      deep: true,
      immediate: true,
      handler: function (val, old) {
        console.log('defauleValue', val, old)
        if (val == old) return
        if (this.type == 'time') {
          if (val) {
            let arr = val.split(":")
            if (arr.length == 2) {
              this.selectH1 = arr[0]
              this.selectM1 = arr[1]
              this.valueStr = this.changeValue(false)
            }
          }
        } else {
          if (val && val.length == 2) {
            let arr1 = val[0].split(":")
            if (arr1.length == 2) {
              this.selectH1 = arr1[0]
              this.selectM1 = arr1[1]
            }
            let arr2 = val[1].split(":")
            if (arr2.length == 2) {
              this.selectH2 = arr2[0]
              this.selectM2 = arr2[1]
            }
            this.valueStr = this.changeValue(false)
          }
        }
      }
    }
  },
  data () {
    return {
      valueStr: '',
      selectH1: '',
      selectH2: '',
      selectM1: '',
      selectM2: '',
    }
  },
  methods: {
    changeH1: function (value, index) {
      this.selectH1 = value
      this.valueStr = this.changeValue(true)

    },
    changeM1: function (value, index) {
      this.selectM1 = value
      this.valueStr = this.changeValue(true)
    },
    changeH2: function (value, index) {
      this.selectH2 = value
      this.valueStr = this.changeValue(true)
    },
    changeM2: function (value, index) {
      this.selectM2 = value
      this.valueStr = this.changeValue(true)
    },
    changeValue: function (isEmit) {
      this.selectH1 = this.selectH1 ? this.selectH1 : '00'
      if (this.selectH1 == '24') {
        this.selectM1 = '00'
      } else {
        this.selectM1 = this.selectM1 ? this.selectM1 : '00'
      }
      this.selectH2 = this.selectH2 ? this.selectH2 : this.selectH1
      if (this.selectH2 == '24') {
        this.selectM2 = '00'
      } else if (this.selectH2 == '00') {
        if (this.selectM2 == '00') {
          this.selectM2 = '05'
        } else {
          this.selectM2 = this.selectM2 ? this.selectM2 : '05'
        }
      } else {
        this.selectM2 = this.selectM2 ? this.selectM2 : this.selectM1
      }
      if (this.type == 'time') {
        if (isEmit) this.$emit('change', this.selectH1 + ":" + this.selectM1)
        return this.selectH1 + ":" + this.selectM1
      } else {
        if (isEmit) this.$emit('change', [this.selectH1 + ":" + this.selectM1, this.selectH2 + ":" + this.selectM2])
        return this.selectH1 + ":" + this.selectM1 + " - " + this.selectH2 + ":" + this.selectM2
      }
    },
    clearV: function () {
      this.valueStr = ''
      this.selectH1 = ''
      this.selectH2 = ''
      this.selectM1 = ''
      this.selectM2 = ''
      if (this.type == 'time') {
        this.$emit('change', '')
      } else {
        this.$emit('change', [])
      }
    }
  },
  mounted () {

  }
}
</script>
<style lang="less" scoped>
.timeRangeBox {
  display: flex;

  > div {
    flex: 1;
    .timeRangeTitle {
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      line-height: 32px;
      border-bottom: 1px solid #e8eaec;
    }
  }

  > div:not(:last-child) {
    border-right: 2px solid #e8eaec;
  }
}
.timeOptionContainer {
  display: flex;
  flex: 1;

  .hourContainer,
  .minContainer {
    width: 60px;
    height: 144px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  > div {
    flex: 1;
    text-align: center;

    // height: 144px;
    // overflow: hidden;

    .timeItem {
      cursor: pointer;
      width: 60px;
      height: 24px;
      line-height: 24px;
    }

    .timeItem:hover {
      background: #f3f3f3;
    }

    .timeItem.active {
      color: #0066ff;
      background: #f3f3f3;
      font-weight: 500;
    }
  }

  > div:not(:last-child) {
    border-right: 1px solid #e8eaec;
  }
}
</style>